// extracted by mini-css-extract-plugin
export var fallback = "Silks-module--fallback--9910b";
export var skeletonMargin = "Silks-module--skeletonMargin--bbac0";